// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Locale } from '../locale';
import { createElement } from '../common';

export const Filters = {
    create(config, handler) {
        if (config.render) {
            return config.render(config, handler);
        }

        if (config.type === 'date') {
            return this.createDate(config, handler);
        }

        if (config.options) {
            if (config.multi) {
                return this.createMultiEnum(config, handler);
            }
            return this.createEnum(config, handler);
        }

        return this.createText(config, handler);
    },

    createText(config, handler) {
        return createElement('input[type="text"]', {
            id: config.idPrefix ? `${config.idPrefix}-search-text-${config.name}` : null,
            name: `searchFilter[${config.name}][searchText]`,
            placeholder: config.placeholder || null,
            pattern: config.pattern || null,
            title: (config.pattern && config.placeholder) || null,
            onkeyup: (config.live && handler) || null,
            value: config.value || null,
            class: config.cls || null,
        });
    },

    createEnum(config, handler) {
        return createElement('select',
            {
                id: config.idPrefix ? `${config.idPrefix}-type-filter` : null,
                name: `searchFilter[${config.name}][searchText]`,
                onchange: handler || null,
            },
            this.enumOptionsView(config.options, config.value)
        );
    },

    createMultiEnum(config, handler) {
        return createElement('.dropdown',
            createElement('.input-group',
                createElement('input.form-control[type="text"][readonly]', {
                    placeholder: config.placeholder || null,
                }),
                createElement('span.input-group-btn',
                    createElement('span.btn.dropdown-toggle',
                        createElement('button[type="button"]',
                            createElement('span.caret')
                        )
                    )
                )
            ),
            createElement('ul.dropdown-menu.pull-right',
                {
                    onclick(event) {
                        event.stopPropagation();
                    },
                },
                Object.isArray(config.options) && config.options.length ? createElement('li',
                    createElement('div.dropdown-menu-content.checkbox-group',
                        config.options.map(function (option) {
                            return createElement('label',
                                createElement('input[type="checkbox"]', {
                                    value: option.value,
                                    checked: !config.value || config.value.indexOf(option.value) !== -1 ? true : null,
                                    onclick(event) {
                                        const element = event.element();
                                        const output = element.up('th').down('input[type=text]');
                                        const input = element.up('th').select('input[type=checkbox]:checked');
                                        const total = element.up('th').select('input[type=checkbox]');
                                        if (!input.length) {
                                            output.value = config.locale.lmsg('none');
                                        } else if (input.length === total.length) {
                                            output.value = '';
                                        } else {
                                            const value = [];
                                            input.each(function (el) {
                                                value.push(el.value[0].toUpperCase());
                                            });
                                            output.value = value.join(', ');
                                        }

                                        if (Object.isFunction(handler)) {
                                            handler();
                                        }
                                    },
                                }),
                                ` ${option.value}`
                            );
                        })
                    )
                ) : ''
            )
        );
    },

    createDate(config, handler) {
        let i;
        const locale = config.locale || new Locale();

        const hour = createElement('select');
        for (i = 0; i < 24; i++) {
            hour.children.push(
                createElement('option', { value: i }, (i < 10 ? '0' : '') + i)
            );
        }

        const minute = createElement('select');
        for (i = 0; i < 60; i++) {
            minute.children.push(
                createElement('option', { value: i }, (i < 10 ? '0' : '') + i)
            );
        }

        const day = createElement('select');
        for (i = 1; i < 32; i++) {
            day.children.push(
                createElement('option', { value: i }, (i < 10 ? '0' : '') + i)
            );
        }

        const month = createElement('select');
        for (i = 0; i < 12; i++) {
            month.children.push(
                createElement('option', { value: i }, locale.lmsg(`month${i + 1}`))
            );
        }

        const year = createElement('select');
        for (i = 2000; i <= (new Date()).getFullYear(); i++) {
            year.children.push(
                createElement('option', { value: i }, i)
            );
        }

        return createElement('.dropdown',
            createElement('.input-group',
                {
                    onclick: function (event) {
                        this.onDateSearchFilterOpen(event.element().up('.dropdown'));
                    }.bind(this),
                },
                createElement('input.form-control[type="text"][readonly]', {
                    placeholder: config.placeholder || null,
                }),
                createElement('span.input-group-btn',
                    createElement('span.btn.dropdown-toggle',
                        createElement('button[type="button"]',
                            createElement('span.caret')
                        )
                    )
                )
            ),
            createElement('ul.dropdown-menu',
                {
                    onclick(event) {
                        event.stop();
                    },
                },
                createElement('li',
                    createElement('.filter-date-form',
                        createElement('.form-row',
                            createElement('.inline-fields-group',
                                hour, ' : ', minute
                            ),
                            createElement('.inline-fields-group',
                                day, ' ', month, ' ', year
                            ),
                            createElement('.inline-fields-group',
                                createElement('span.btn',
                                    createElement('button[type="button"]', {
                                        onclick: function (event) {
                                            event.element().up('.dropdown').toggleClassName('open');
                                            this.onDateSearchFilterOpen(event.element().up('.dropdown'));
                                            this.onDateSearchFilterChange(event.element().up('.dropdown'));
                                            if (Object.isFunction(handler)) {
                                                handler();
                                            }
                                        }.bind(this),
                                    }, locale.lmsg('apply'))
                                ),
                                createElement('span.btn',
                                    createElement('button[type="button"]', {
                                        onclick: function (event) {
                                            event.element().up('.dropdown').toggleClassName('open');
                                            event.element().up('.dropdown').down('input').value = '';
                                            this.onDateSearchFilterOpen(event.element().up('.dropdown'));
                                            if (Object.isFunction(handler)) {
                                                handler();
                                            }
                                        }.bind(this),
                                    }, locale.lmsg('clear'))
                                )
                            )
                        ),
                        createElement('.form-row.filter-actions-row',
                            createElement('a.toggler', {
                                onclick: function (event) {
                                    this.onDateSearchFilterModify(event.element().up('.dropdown'), new Date(new Date().getTime() - (3600 * 1000)));
                                    if (Object.isFunction(handler)) {
                                        handler();
                                    }
                                }.bind(this),
                            }, locale.lmsg('hourAgo')),
                            ' ',
                            createElement('a.toggler', {
                                onclick: function (event) {
                                    this.onDateSearchFilterModify(event.element().up('.dropdown'), new Date(new Date().getTime() - (86400 * 1000)));
                                    if (Object.isFunction(handler)) {
                                        handler();
                                    }
                                }.bind(this),
                            }, locale.lmsg('prevDay'))
                        )
                    )
                )
            )
        );
    },

    enumOptionsView(options, value) {
        return options.map(function (option) {
            if ('value' === option.type) {
                return this.enumValueView(option, value);
            }
            return this.enumGroupValue(option, value);
        }.bind(this));
    },

    enumValueView(option, value) {
        return createElement('option', {
            value: option.value,
            selected: option.value === value,
        }, option.label.escapeHTML());
    },

    enumGroupValue(option, value) {
        return createElement('optgroup',
            {
                label: option.label,
            },
            this.enumOptionsView(option.options, value)
        );
    },

    onMultiEnumSearchFilterChange(element) {
    },

    onDateSearchFilterOpen(element) {
        if (!element.hasClassName('open')) {
            return;
        }

        let date = new Date(element.down('input').value);
        if (isNaN(date.getTime())) {
            date = new Date();
        }

        this._dateSearchFieldFromDate(element, date);
    },

    onDateSearchFilterChange(element) {
        const date = this._dateSearchFieldToDate(element);

        const yyyy = date.getFullYear();
        const mm = (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1);
        const dd = (date.getDate() < 10 ? '0' : '') + date.getDate();
        const h = (date.getHours() < 10 ? '0' : '') + date.getHours();
        const m = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();

        element.down('input').value = `${yyyy}-${mm}-${dd} ${h}:${m}`;
    },

    onDateSearchFilterModify(element, date) {
        this._dateSearchFieldFromDate(element, date);
    },

    _dateSearchFieldFromDate(element, date) {
        const elements = element.select('select');
        elements[0].value = date.getHours();
        elements[1].value = date.getMinutes();
        elements[2].value = date.getDate();
        elements[3].value = date.getMonth();
        elements[4].value = date.getFullYear();
    },

    _dateSearchFieldToDate(element) {
        const elements = element.select('select');
        return new Date(elements[4].value, elements[3].value, elements[2].value, elements[0].value, elements[1].value);
    },
};



// WEBPACK FOOTER //
// ./jsw/list/filters.js